import styled from "styled-components";

export const ContainerSect = styled.div`
  width: 100%;
  max-width: 1500px;
  padding: 0 20px;
  margin: 0 auto;
`
